import { render, staticRenderFns } from "./OriginalDocumentsFilter.vue?vue&type=template&id=2cad1755"
import script from "./OriginalDocumentsFilter.vue?vue&type=script&lang=js"
export * from "./OriginalDocumentsFilter.vue?vue&type=script&lang=js"
import style0 from "./OriginalDocumentsFilter.vue?vue&type=style&index=0&id=2cad1755&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports